import React, {useEffect, useRef, useState} from "react";
import { NavLink } from "react-router-dom";
import guessSlider from '../assets/Female/guess.jpg';
import mangoSlider from '../assets/Female/mango.jpg';
import parfoisSlider from '../assets/Female/parfois.jpg';
import hugoSlider from '../assets/Female/hugo.jpg';
import mainSlider from '../assets/Female/female-banner.jpg';
import tommySlider from '../assets/Female/tommy.jpg';   
import video from '../assets/slider/female/video-female.webm';
//import video from '../assets/slider/female/female-video.mp4';
import { Autoplay, EffectFade } from 'swiper';

import Productslider from "./Productslider";

import './Header.css';
import BrandFocusSlider from "./BrandFocusSlider";
import {Swiper, SwiperSlide} from "swiper/react";
import useBrands from "../hooks/useBrands";

const bannerListBase = [
    {
        image: tommySlider,
        path: '/brands/tommy-hilfiger?gender=female',
        text: 'SHIKO KOLEKSIONIN',
        brand: 'tommy'
    },
    {
        image: guessSlider,
        path: '/brands/guess?gender=female',
        text: 'SHIKO KOLEKSIONIN',
        brand: 'guess'
    },
    {
        image: parfoisSlider,
        path: '/brands/parfois?gender=female',
        text: 'SHIKO KOLEKSIONIN',
        brand: 'parfois'
    },
    {
        image: hugoSlider,
        path: '/brands/hugo?gender=female',
        text: 'SHIKO KOLEKSIONIN',
        brand: 'hugo'
    },
    {
        image: mangoSlider,
        path: '/brands/mango?gender=female',
        text: 'SHIKO KOLEKSIONIN',
        brand: 'mango'
    }
]

export default function Female() {
    const {brands} = useBrands()
    const [bannerList, setBannerList] = useState(bannerListBase)

    useEffect(() => {
        setBannerList(prevState => prevState.map((item)=>{
            const brandImage = brands.find(b => b.slug === item.brand)?.brandImage;
            return {...item, brandImage}
        }))
    }, [brands]);


    return (

    <div className="bg-gradient-to-b from-neutral-50 to-white">
      <div className="cover-section relative z-0">
          <Swiper
              slidesPerView={1}
              spaceBetween={0}
              loop={true}
              centeredSlides={true}
              autoplay={{
                  delay: 15000,
                  disableOnInteraction: false,
              }}
              pagination={false}
              navigation={false}
              modules={[Autoplay]}
              className="mySwiper"
          >
              {bannerList.map((item, index) => {
                  return (
                      <SwiperSlide key={index}>
                          {({isActive})=>(<>
                              <NavLink
                                  to={item.path}
                                  aria-label={item.text || 'Shiko koleksionin'}
                                  className="block relative albi-grain cursor-pointer"
                              >
                                  {item.brandImage && (
                                      <img
                                          src={item.brandImage}
                                          className={'slider-brandImage animate__animated' + (isActive ? 'animate__slideInRight' : '')}
                                          alt={item.brand}
                                          width="100%"
                                      />
                                  )}
                                  <img
                                      className={'slider-image max-h-[380px] sm:max-h-[500px] lg:max-h-[560px] object-cover'}
                                      src={item.image}
                                      alt=""
                                      width="100%"
                                      style={item.style}
                                  />
                                  <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-black/5 to-transparent pointer-events-none" />
                              </NavLink>
                          </>)}
                      </SwiperSlide>
                  );
              })}
          </Swiper>
      </div>

        {/* Quick links: mbivendosje me fundin e banerit; pa z-10 që seksioni product nga mos mbetet nën to */}
        <div className="-mt-10 sm:-mt-14 relative">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    <NavLink
                        to="/search/female"
                        className="group relative overflow-hidden rounded-2xl bg-white shadow-[0_22px_60px_-40px_rgba(0,0,0,0.65)] ring-1 ring-black/5 hover:ring-black/10 transition"
                    >
                        <div className="absolute inset-0 bg-gradient-to-tr from-black/55 via-black/20 to-transparent z-[1] pointer-events-none group-hover:from-black/60 transition-colors duration-500" />
                        <div
                            className="relative z-0 h-[140px] sm:h-[132px] lg:h-[140px] bg-cover bg-center"
                            style={{ backgroundImage: `url(${mainSlider})` }}
                        />
                        <div className="absolute inset-0 z-[2] p-5 pb-6 flex items-end justify-between">
                            <div className="text-white">
                                <div className="text-[11px] font-semibold tracking-[0.26em] uppercase text-white/80">All Products</div>
                                <div className="mt-1 text-lg font-semibold">Të gjitha</div>
                            </div>
                            <div className="text-white/90 text-sm font-semibold">→</div>
                        </div>
                    </NavLink>

                    <NavLink
                        to="/new-arrivals?gender=female"
                        className="group relative overflow-hidden rounded-2xl bg-white shadow-[0_22px_60px_-40px_rgba(0,0,0,0.65)] ring-1 ring-black/5 hover:ring-black/10 transition"
                    >
                        <div className="absolute inset-0 bg-gradient-to-tr from-black/55 via-black/20 to-transparent z-[1] pointer-events-none group-hover:from-black/60 transition-colors duration-500" />
                        <div
                            className="relative z-0 h-[140px] sm:h-[132px] lg:h-[140px] bg-cover bg-center"
                            style={{ backgroundImage: `url(${parfoisSlider})` }}
                        />
                        <div className="absolute inset-0 z-[2] p-5 pb-6 flex items-end">
                            <div className="text-white">
                                <div className="text-[11px] font-semibold tracking-[0.26em] uppercase text-white/80">New in</div>
                                <div className="mt-1 text-lg font-semibold">Më të rejat</div>
                            </div>
                        </div>
                    </NavLink>

                    <NavLink
                        to="/top-picks?gender=female"
                        className="group relative overflow-hidden rounded-2xl bg-white shadow-[0_22px_60px_-40px_rgba(0,0,0,0.65)] ring-1 ring-black/5 hover:ring-black/10 transition"
                    >
                        <div className="absolute inset-0 bg-gradient-to-tr from-black/55 via-black/20 to-transparent z-[1] pointer-events-none group-hover:from-black/60 transition-colors duration-500" />
                        <div
                            className="relative z-0 h-[140px] sm:h-[132px] lg:h-[140px] bg-cover bg-center"
                            style={{ backgroundImage: `url(${hugoSlider})` }}
                        />
                        <div className="absolute inset-0 z-[2] p-5 pb-6 flex items-end">
                            <div className="text-white">
                                <div className="text-[11px] font-semibold tracking-[0.26em] uppercase text-white/80">Top Picks</div>
                                <div className="mt-1 text-lg font-semibold">Top Zgjedhjet</div>
                            </div>
                        </div>
                    </NavLink>

                    <NavLink
                        to="/brands"
                        className="group relative overflow-hidden rounded-2xl bg-white shadow-[0_22px_60px_-40px_rgba(0,0,0,0.65)] ring-1 ring-black/5 hover:ring-black/10 transition"
                    >
                        <div className="absolute inset-0 bg-gradient-to-tr from-black/55 via-black/20 to-transparent z-[1] pointer-events-none group-hover:from-black/60 transition-colors duration-500" />
                        <div
                            className="relative z-0 h-[140px] sm:h-[132px] lg:h-[140px] bg-cover bg-center"
                            style={{ backgroundImage: `url(${guessSlider})` }}
                        />
                        <div className="absolute inset-0 z-[2] p-5 pb-6 flex items-end justify-between">
                            <div className="text-white">
                                <div className="text-[11px] font-semibold tracking-[0.26em] uppercase text-white/80">Brands</div>
                                <div className="mt-1 text-lg font-semibold">Brendet</div>
                            </div>
                            <div className="text-white/90 text-sm font-semibold">→</div>
                        </div>
                    </NavLink>
                </div>
            </div>
        </div>


        <div className="cart-section relative z-[3] mt-10 sm:mt-20">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="flex items-end justify-between gap-6 py-4">
                    <div>
                        <div className="text-[11px] font-semibold tracking-[0.22em] text-neutral-500 uppercase">
                            NEW COLLECTION
                        </div>
                        <div className="title_block !mt-1">
                            Më të rejat
                        </div>
                    </div>
                    <NavLink
                        to="/new-arrivals?gender=female"
                        className="inline-flex items-center gap-2 rounded-full border border-neutral-200 bg-white px-4 py-2 text-xs font-semibold tracking-wide text-neutral-800 shadow-sm hover:border-neutral-300 hover:bg-neutral-50 transition-colors"
                    >
                        Shiko më shumë
                        <span aria-hidden="true">→</span>
                    </NavLink>
                </div>
            </div>
            <Productslider start='1' limit='20' type='newin' dataSource='new-arrivals' gender='female' eager prefetchPx={2000}/>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-9">
                <div className="flex items-end justify-between gap-6 py-4">
                    <div>
                        <div className="text-[11px] font-semibold tracking-[0.22em] text-neutral-500 uppercase">
                            TOP PICKS
                        </div>
                        <div className="title_block !mt-1">
                            Top Zgjedhjet
                        </div>
                    </div>
                    <NavLink
                        to="/top-picks?gender=female"
                        className="inline-flex items-center gap-2 rounded-full border border-neutral-200 bg-white px-4 py-2 text-xs font-semibold tracking-wide text-neutral-800 shadow-sm hover:border-neutral-300 hover:bg-neutral-50 transition-colors"
                    >
                        Shiko më shumë
                        <span aria-hidden="true">→</span>
                    </NavLink>
                </div>
            </div>
            <Productslider start='1' limit='20' type='toppicks' dataSource='top-picks' gender='female' eager prefetchPx={2000}/>
        </div>

      <div className='section-5 video-sec'>
        <div id="shopify-section-16141564777b64a0a2" className="shopify-section index-section section-video wow fadeInUp  animated">

          <div data-section-id="16141564777b64a0a2">
            <div className="distance">
              <div className="container-1320">
                <div className="block">
                  <div className="item youtube position-relative rounded-2xl overflow-hidden shadow-sm ring-1 ring-black/5">

                    <video src={video} muted autoPlay loop width='100%' height='100%' webkit-playsinline="true" playsInline />

                    {/* <div className="block_title text-center">
                      <div className="sub-title-1 text-uppercase">NEW ARRIVALS</div>
                      <div className="title_block">ËSHTË MOMENTI YT</div>
                      <div className="sub-title-2">Trendet e fundit i gjeni vetëm në Albi Online</div> 
                      <div className="sub-title-4 text-uppercase"></div>
                    </div> */}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-10">
            <div className="text-[11px] font-semibold tracking-[0.22em] text-neutral-500 uppercase">
                Brendet
            </div>
            <div className="title_block !mt-1">
                Në Fokus
            </div>
        </div>
        <div className="pb-6">
            <BrandFocusSlider gender={'female'}/>
        </div>

    </div>
  )
}